import { getLevelArrayMetric as r } from "../index4.js";
import { getLevelClearInternalHeight as t } from "../level-metrics/index9.js";
const n = (e) => r(e, t);
export {
  n as getLevelArrayClearInternalHeight
};
//# sourceMappingURL=index3.js.map
